/* @generated from adl module ferovinum.datacontracts.capitalisedexpense */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface CapitalisedExpenseRawRecord {
  id: common_strings.StringNE;
  dealLegId: common_strings.StringNE;
  descriptionId: common_strings.StringNE;
  productionOrderTaskRunId: (common_strings.StringNE|null);
  amountPaid: common.BigDecimal;
  pricePerUnit: common.BigDecimal;
  expenseDate: common.LocalDate;
  rolledFromCapexId: (common_strings.StringNE|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeCapitalisedExpenseRawRecord(
  input: {
    id: common_strings.StringNE,
    dealLegId: common_strings.StringNE,
    descriptionId: common_strings.StringNE,
    productionOrderTaskRunId: (common_strings.StringNE|null),
    amountPaid: common.BigDecimal,
    pricePerUnit: common.BigDecimal,
    expenseDate: common.LocalDate,
    rolledFromCapexId: (common_strings.StringNE|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): CapitalisedExpenseRawRecord {
  return {
    id: input.id,
    dealLegId: input.dealLegId,
    descriptionId: input.descriptionId,
    productionOrderTaskRunId: input.productionOrderTaskRunId,
    amountPaid: input.amountPaid,
    pricePerUnit: input.pricePerUnit,
    expenseDate: input.expenseDate,
    rolledFromCapexId: input.rolledFromCapexId,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const CapitalisedExpenseRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.capitalisedexpense","decl":{"annotations":[{"value":{"datasetName":"raw_capitalised_expenses"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"dealLegId","default":{"kind":"nothing"},"name":"dealLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"descriptionId","default":{"kind":"nothing"},"name":"descriptionId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"productionOrderTaskRunId","default":{"kind":"nothing"},"name":"productionOrderTaskRunId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"amountPaid","default":{"kind":"nothing"},"name":"amountPaid","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"pricePerUnit","default":{"kind":"nothing"},"name":"pricePerUnit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseDate","default":{"kind":"nothing"},"name":"expenseDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"rolledFromCapexId","default":{"kind":"nothing"},"name":"rolledFromCapexId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"CapitalisedExpenseRawRecord","version":{"kind":"nothing"}}};

export const snCapitalisedExpenseRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.capitalisedexpense", name:"CapitalisedExpenseRawRecord"};

export function texprCapitalisedExpenseRawRecord(): ADL.ATypeExpr<CapitalisedExpenseRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snCapitalisedExpenseRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.capitalisedexpense.CapitalisedExpenseRawRecord" : CapitalisedExpenseRawRecord_AST
};
